import { useState } from "react";
import { Plus, Package } from "lucide-react";

export const CutPieceOrder = ({ product, onAdd }) => {
  const lengths = product.cut_lengths || ["100 cms", "80 cms"];
  const [length, setLength] = useState(lengths[0]);
  const [packs, setPacks] = useState(1);
  const photos = product.gallery || [product.sample_image_url];
  const api = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="space-y-8" data-testid="cut-piece-order">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3">
        {photos.map((p, i) => (
          <div
            key={p}
            className="rounded-sm overflow-hidden border"
            style={{ borderColor: "var(--mp-line)" }}
            data-testid={`cut-piece-photo-${i}`}
          >
            <img
              src={`${api}${p}`}
              alt={`600 Gold cut piece bundle ${i + 1}`}
              loading="lazy"
              className="w-full h-full object-cover aspect-[4/3]"
            />
          </div>
        ))}
      </div>

      <div
        className="border rounded-sm p-6 sm:p-8 max-w-2xl"
        style={{ borderColor: "var(--mp-line)", backgroundColor: "var(--mp-card)" }}
      >
        <div className="flex items-start gap-3 mb-6">
          <Package className="w-5 h-5 mt-0.5 shrink-0" style={{ color: "var(--mp-copper)" }} />
          <p
            className="text-sm"
            style={{ color: "var(--mp-muted)", fontFamily: "'Manrope', sans-serif", lineHeight: 1.7 }}
          >
            Each bundle is an assorted pack of <strong style={{ color: "var(--mp-text)" }}>50 colours</strong> —
            one piece per colour, pre-cut and ready for the counter. Choose your cut length and how many packs you need.
          </p>
        </div>

        <p
          className="text-[10px] tracking-[0.18em] uppercase mb-2.5"
          style={{ color: "var(--mp-copper)", fontFamily: "'Manrope', sans-serif" }}
        >
          Cut length
        </p>
        <div className="flex flex-wrap gap-2 mb-6">
          {lengths.map((l) => (
            <button
              key={l}
              onClick={() => setLength(l)}
              data-testid={`cut-length-${l.replace(/\s+/g, "-")}`}
              className="px-5 py-2.5 text-sm font-medium rounded-sm border transition-colors"
              style={{
                borderColor: length === l ? "var(--mp-copper)" : "var(--mp-line)",
                backgroundColor: length === l ? "var(--mp-copper-solid)" : "transparent",
                color: length === l ? "#FFFFFF" : "var(--mp-text)",
                fontFamily: "'Manrope', sans-serif",
              }}
            >
              {l}
            </button>
          ))}
        </div>

        <p
          className="text-[10px] tracking-[0.18em] uppercase mb-2.5"
          style={{ color: "var(--mp-copper)", fontFamily: "'Manrope', sans-serif" }}
        >
          Number of packs
        </p>
        <div className="flex items-center gap-4 mb-7">
          <input
            type="number"
            min="1"
            max="200"
            value={packs}
            onChange={(e) => setPacks(e.target.value === "" ? "" : Math.max(1, Math.min(200, Number(e.target.value) || 1)))}
            onBlur={() => setPacks((p) => (p === "" ? 1 : p))}
            data-testid="cut-piece-packs"
            className="w-24 px-3 py-2.5 text-sm rounded-sm border bg-transparent outline-none"
            style={{
              borderColor: "var(--mp-line)",
              color: "var(--mp-text)",
              fontFamily: "'Manrope', sans-serif",
            }}
          />
          <span className="text-sm" style={{ color: "var(--mp-muted)", fontFamily: "'Manrope', sans-serif" }}>
            {(Number(packs) || 1)} {(Number(packs) || 1) === 1 ? "pack" : "packs"} &times; 50 = {(Number(packs) || 1) * 50} pieces
          </span>
        </div>

        <button
          onClick={() =>
            onAdd({
              quality_id: product.id,
              quality_name: product.name,
              cut_length: length,
              pieces_per_pack: product.pieces_per_pack || 50,
              thans: Number(packs) || 1,
              image_url: `${api}${photos[0]}`,
            })
          }
          data-testid="cut-piece-add"
          className="flex items-center justify-center gap-2 w-full sm:w-auto sm:px-10 text-sm font-medium py-3.5 rounded-sm transition-opacity hover:opacity-90"
          style={{
            backgroundColor: "var(--mp-copper-solid)",
            color: "#FFFFFF",
            fontFamily: "'Manrope', sans-serif",
          }}
        >
          <Plus className="w-4 h-4" />
          Add to order
        </button>
      </div>
    </div>
  );
};
